import {
  getBuddyMarketingUrl,
  getMarketingUrl,
  getGitHubUrl,
  getTwitterUrl
} from '~/helpers/url';
import heart from '~/assets/img/heart.svg';
import twitterIcon from '~/assets/img/twitter-icon.svg';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="text text--light">
          <div className="item">
            In case of questions and suggestions, please{' '}
            <a href={getGitHubUrl('issues')}>open an issue</a>
          </div>
          <div className="item">|</div>
          <div className="item">
            <a href={getMarketingUrl('terms-of-service')}>
              Terms
            </a>
          </div>
          <div className="item">|</div>
          <div className="item">
            <a href={getMarketingUrl('privacy-policy')}>
              Privacy
            </a>
          </div>
          <div className="item">|</div>
          <div className="item">
            <a href={getTwitterUrl()}>
              <img className="footer__pic" alt="Repman Twitter" src={twitterIcon} />
            </a>
          </div>
        </div>
        <div className="text footer__copy text--light">
          made with <img src={heart} alt="heart" className="footer__pic" /> by{' '}
          <a href={getBuddyMarketingUrl()} className="links" rel="nofollow">
            Buddy
          </a>
        </div>
      </div>
    </footer>
  );
}
